import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { HomeRoutingModule } from './home-routing.module';
import { HomeComponent } from './home.component';
import { ButtonModule } from 'primeng/button';
import { FirmaComponent } from 'src/tests/components/firma/firma.component';
import { HeaderModule } from '../header/header.module';
import { FooterModule } from '../footer/footer.module';


@NgModule({
  declarations: [HomeComponent, FirmaComponent],
  imports: [
    CommonModule,
    HomeRoutingModule,
    ButtonModule,
    HeaderModule,
    FooterModule
  ]
})
export class HomeModule { }
